import { useState, useEffect } from "react";
import axios from "axios";
import DataTable_Component from "../../components/movingnotmoving/Data Table/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faPenToSquare,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";
import Layouts from "../../layouts/layouts";
import VehicleDetailModal from "../../components/movingnotmoving/MovingNotmoving details";

export default function MovingNotmoving() {
  const title = "Moving and Not Moving Vehicle Details";
  const [apistate, setApiState] = useState([]);
  const [summary, setSummary] = useState({
    total: 0,
    moving: 0,
    notMoving: 0,
  });
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);

  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [showVehicleDetailModal, setShowVehicleDetailModal] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  const columns = [
    {
      name: <b>Hub Name</b>,
      selector: (row) => row.hubName,
      sortable: true,
    },
    {
      name: <b>Total Count</b>,
      selector: (row) => row.vehicleCount,
      sortable: true,
    },
    {
      name: <b>Moving Count</b>,
      selector: (row) => row.movingVehicleCount,
      sortable: true,
    },
    {
      name: <b>Not-Moving Count</b>,
      selector: (row) => row.nonMovingVehicleCount,
      sortable: true,
    },
    {
      name: <b>Moving Vehicles</b>,
      cell: (row) => {
        const movingVehicles =
          row.vehicleSummaries
            ?.filter((vehicle) => vehicle.moving === true)
            .map((vehicle) => vehicle.numberplate) || [];

        return (
          <div style={{ position: "relative", zIndex: 1 }}>
            {movingVehicles.length > 0 ? (
              movingVehicles.map((numberplate, index) => (
                <p key={index} style={{ margin: "0" }}>
                  {numberplate}
                </p>
              ))
            ) : (
              <p style={{ margin: "0" }}>-</p>
            )}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: <b>Not-Moving Vehicles</b>,
      cell: (row) => {
        const movingVehicles =
          row.vehicleSummaries
            ?.filter((vehicle) => vehicle.moving === false)
            .map((vehicle) => vehicle.numberplate) || [];

        return (
          <div style={{ position: "relative", zIndex: 1 }}>
            {movingVehicles.length > 0 ? (
              movingVehicles.map((numberplate, index) => (
                <p key={index} style={{ margin: "0" }}>
                  {numberplate}
                </p>
              ))
            ) : (
              <p style={{ margin: "0" }}>-</p>
            )}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: <b>Action</b>,
      cell: (row) => (
        <>
          <button
            onClick={() => viewVehicle(row)}
            className="btn btn-primary btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>
        </>
      ),
    },
  ];

  const fetchData = async (page) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v2/vehicles/daily/summaries/hub`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (Array.isArray(response.data.hubs)) {
        setApiState(response.data.hubs);

        const total = response.data.hubs.reduce(
          (sum, hub) => sum + hub.vehicleCount,
          0,
        );

        const moving = response.data.hubs.reduce(
          (sum, hub) => sum + hub.movingVehicleCount,
          0,
        );

        const notMoving = response.data.hubs.reduce(
          (sum, hub) => sum + hub.nonMovingVehicleCount,
          0,
        );

        setSummary({
          total,
          moving,
          notMoving,
        });
      } else {
        console.error("Unexpected data format from API", response.data);
      }
      setApiCol(columns);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const setStoreBtn = () => {
    setOpen_add_modal({ render: !open_add_modal.render, modal_open: true });
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const viewVehicle = (hubs) => {
    setSelectedVehicle(hubs);
    setShowVehicleDetailModal(true);
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />

      <VehicleDetailModal
        show={showVehicleDetailModal}
        onHide={() => setShowVehicleDetailModal(false)}
        hubs={selectedVehicle}
      />
      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
              </div>
              <div className="card-body">
                {apistate.length > 0 ? (
                  <DataTable_Component
                    searchBy="hubName"
                    title_btn={true}
                    title="Vehicle List"
                    apidata={apistate}
                    columns={apicol}
                    summary={summary}
                    setSummary={setSummary}
                  />
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
